// AI-CONTEXT: See docs/features/materiaal-uitkomsten-tegels.md
import Modal from '../common/Modal'
import Table from '../common/table/Table'
import TableCell from '../common/table/TableCell'
import unknownReason from '../../helpers/materialsHelpers/unknownReason'

/**
 * @typedef {object} UnknownRow
 * @property {string} key
 * @property {string} [project] - Projectnaam, alleen bij 'alle projecten'
 * @property {string} Title - Materiaal
 * @property {string} Status - Reden
 * @property {number} Count - Registraties
 */

const columns = (withProject) => [
    ...(withProject ? [{ key: 'project', label: 'PROJECT', searchable: false }] : []),
    { key: 'title', label: 'MATERIAAL', searchable: false },
    { key: 'reason', label: 'REDEN', searchable: false },
    { key: 'count', label: 'REGISTRATIES', searchable: false },
    { key: 'action', label: 'WAT JE KUNT DOEN', searchable: false },
]

/**
 * Welke registraties niet meetellen in de besparingen, en waarom. Per
 * materiaal en reden met aantallen — bewust zonder adressen of huishoudens:
 * een portfolio en Deccos kijken hier mee bij andere organisaties.
 * AI-CONTEXT: See CLAUDE.md (Volledige transparantie — privacy gaat voor)
 *
 * @param {object} props
 * @param {Array<UnknownRow>|null} props.rows - null = venster dicht
 * @param {string} props.scopeLabel - Projectnaam of 'alle projecten'
 * @param {boolean} props.withProject - Toon een kolom met het project
 * @param {() => void} props.onClose - Sluit het venster
 */
const MaterialUnknownModal = ({ rows, scopeLabel, withProject, onClose }) => {
    if (!rows) return null

    return (
        <Modal
            modalOpen
            setModalOpen={onClose}
            pageHeader={`Niet meegeteld — ${scopeLabel}`}
            description='Deze registraties tellen niet mee in de bespaarde CO2 en de besparing op de energierekening. Het getal is daardoor te laag; per regel staat wat er mist.'
            content={(
                <Table
                    ariaLabel='Niet meegeteld'
                    columns={columns(withProject)}
                    items={rows}
                    getItemKey={(row) => row.key}
                    showSearch={false}
                    emptyMessage='Alles telt mee.'
                    renderRow={(row) => {
                        const reason = unknownReason(row.Status)
                        return (
                            <>
                                {withProject && <TableCell>{row.project}</TableCell>}
                                <TableCell>{row.Title || '—'}</TableCell>
                                <TableCell>{reason.label}</TableCell>
                                <TableCell>{row.Count}</TableCell>
                                <TableCell>{reason.action}</TableCell>
                            </>
                        )
                    }}
                />
            )}
            hideConfirm
            cancelLabel='Sluiten'
        />
    )
}

export default MaterialUnknownModal
